import moment from 'moment';
import { BasicMaturity, SecurityType } from '../../../types/deal.types';
import { DealsMaturities } from '../../../helpers/deals/maturity';

export const YEARS_LIMIT = 31;

export function getPar(maturities: BasicMaturity[]) {
  return maturities
    .map(m => DealsMaturities.getSizeInMillions(m))
    .reduce((acc, curr) => {
      return typeof curr === 'number' ? acc + curr : acc;
    }, 0);
}

export function structureExportValueGetter({ data }) {
  const maturities = data.maturities.map(
    ({ chartDate, numberBonds, presentValue, securityType }) => ({
      year: moment(chartDate).year(),
      numberBonds,
      presentValue,
      securityType
    })
  );

  return Array.from(new Set(maturities.map(m => m.year)))
    .sort((year1, year2) => (year1 <= year2 ? -1 : 1))
    .map(year => ({
      year,
      ...maturities
        .filter(m => m.year === year)
        .reduce(
          (acc, m) => ({
            ...acc,
            ...(m.securityType === SecurityType.option ||
            m.securityType === SecurityType.put
              ? { putPar: acc.putPar + m.numberBonds }
              : { par: acc.par + DealsMaturities.getSizeInMillions(m) })
          }),
          { par: 0, putPar: 0 }
        )
    }));
}

export function structureValueGetter({ data, context: { getStructureDate } }) {
  const currentYear = moment(getStructureDate(data)).year();
  const years = Array(YEARS_LIMIT)
    .fill(0)
    .map((_value, index) => {
      const year = currentYear + index;
      const maturities = data.maturities.filter(m => moment(m.chartDate).year() === year);
      const par = getPar(maturities); //combine all maturities for given year

      return { year, par, maturityIds: maturities.map(m => m.id) };
    });

  const outsidePar = getPar(
    data.maturities.filter(m => moment(m.chartDate).year() > currentYear + 30)
  );

  years.push({
    year: Number.POSITIVE_INFINITY,
    par: outsidePar,
    maturityIds: []
  }); //combined par for maturities outside limit

  return years;
}
